/** 保存先の実装（ブラウザの localStorage）。application/repository.ts の StoragePort を満たす */
import type { StoragePort } from '../application/repository';

/** ブラウザの localStorage。使えない環境（プライベートモードの一部など）では null */
export function browserStorage(): StoragePort | null {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch {
    return null;
  }
}

/** ブラウザの sessionStorage（タブを閉じるまで残る）。使えない環境では null */
export function browserSessionStorage(): StoragePort | null {
  try {
    return typeof window !== 'undefined' ? window.sessionStorage : null;
  } catch {
    return null;
  }
}
